/**
 * @description List of sorters that are used often in antd table column
 */

import { hasValue } from 'utils/hasValue';

/**
 * @description: sort by descending time
 */
export function sortByTime(a?: string | number, b?: string | number): number {
  if (!hasValue(a) || !hasValue(b)) return 0;
  return new Date(a).getTime() - new Date(b).getTime();
}

/**
 * @description: sort by amount
 */
export function sortByAmount(a?: string | number, b?: string | number): number {
  if (!hasValue(a) || !hasValue(b)) return 0;

  if (typeof a === 'number' && typeof b === 'number') {
    return a - b;
  }

  if (typeof a === 'string' && typeof b === 'string') {
    return Number.parseFloat(a) - Number.parseFloat(b);
  }

  return 0;
}

export function sortByText(a?: string, b?: string): number {
  if (!hasValue(a) || !hasValue(b)) return 0;

  return a < b ? -1 : 1;
}
